
$( document ).ready(function() {

  /*----------------------
    Cart Checkout Feature
  -----------------------*/

  //if all perishables, add the checkout button
  if($('#csShippingAppCode').length){  
     if($('#contains-subscriptions').length){
        $('#zipForm').remove();
        $('#check-zip-container').find('h2').first().text('Your Order Contains A Subscription');
        $('#check-zip-container').find('p').first().text('We will ship your order on the next available shipment window, directions will be sent to you to change future shipment days.');
       
        $('#checkout-button').removeClass('hidden').addClass('non-perishables');
       
     }
  } else {
    $('#checkout-button').removeClass('hidden').addClass('non-perishables');
  }

  //run the zip form to check for 1 or 2 day shipping
  $("#zipForm").submit(function(event) {
    event.preventDefault(); // Prevent default form submission
    var zipCode = $("#zip").val();
    var validZips = ["75206","77375","70515","70532","70537","70546","70549","70581","70591","70601","70602","70605","70606","70607","70609","70611","70612","70615","70616","70629","70630","70631","70632","70633","70634","70637","70638","70639","70640","70643","70644","70645","70646","70647","70648","70650","70651","70652","70653","70654","70655","70656","70657","70658","70659","70660","70661","70662","70663","70664","70665","70668","70669","71001","71002","71003","71004","71006","71007","71008","71009","71016","71018","71019","71021","71023","71024","71027","71028","71029","71030","71032","71033","71034","71037","71038","71039","71040","71043","71044","71045","71046","71047","71048","71049","71050","71051","71052","71055","71058","71060","71061","71063","71064","71065","71066","71067","71068","71069","71070","71071","71072","71073","71075","71078","71079","71080","71082","71101","71102","71103","71104","71105","71106","71107","71108","71109","71110","71111","71112","71113","71115","71118","71119","71120","71129","71130","71133","71134","71135","71136","71137","71138","71148","71149","71150","71151","71152","71153","71154","71156","71161","71162","71163","71164","71165","71166","71171","71172","71463","71801","71802","71820","71822","71823","71825","71826","71827","71828","71831","71832","71833","71834","71835","71836","71837","71838","71839","71840","71841","71842","71845","71846","71847","71851","71852","71853","71854","71855","71857","71858","71859","71860","71861","71862","71864","71865","71866","73002","73003","73004","73007","73008","73010","73011","73012","73013","73016","73018","73019","73020","73022","73023","73025","73026","73027","73028","73030","73031","73032","73034","73036","73039","73044","73045","73049","73050","73051","73052","73054","73055","73057","73058","73059","73064","73065","73066","73067","73068","73069","73070","73071","73072","73074","73075","73078","73079","73080","73082","73083","73084","73085","73086","73089","73090","73092","73093","73095","73097","73098","73099","73101","73102","73103","73104","73105","73106","73107","73108","73109","73110","73111","73112","73113","73114","73115","73116","73117","73118","73119","73120","73121","73122","73123","73124","73125","73126","73127","73128","73129","73130","73131","73132","73134","73135","73136","73137","73139","73140","73141","73142","73143","73144","73145","73146","73147","73148","73149","73150","73151","73152","73153","73154","73155","73156","73157","73159","73160","73162","73163","73164","73165","73167","73169","73170","73172","73173","73178","73179","73184","73189","73190","73194","73195","73196","73301","73344","73401","73402","73403","73425","73430","73432","73433","73434","73435","73436","73437","73438","73439","73440","73441","73442","73443","73444","73446","73447","73448","73449","73450","73453","73455","73456","73458","73459","73460","73461","73463","73481","73487","73488","74059","74062","74074","74075","74076","74077","74078","74701","74702","74720","74721","74722","74723","74724","74726","74727","74728","74729","74730","74731","74733","74734","74735","74736","74737","74738","74740","74741","74743","74745","74747","74748","74750","74752","74753","74754","74755","74756","74759","74760","74761","74764","74766","74801","74802","74804","74818","74824","74826","74829","74830","74831","74832","74833","74834","74837","74840","74851","74852","74854","74855","74856","74857","74859","74860","74864","74866","74868","74869","74872","74873","74875","74878","74881","74884","75001","75002","75006","75007","75009","75010","75011","75013","75014","75015","75016","75017","75019","75020","75021","75022","75023","75024","75025","75026","75027","75028","75029","75030","75032","75033","75034","75035","75036","75038","75039","75040","75041","75042","75043","75044","75045","75046","75047","75048","75049","75050","75051","75052","75053","75054","75056","75057","75058","75059","75060","75061","75062","75063","75064","75065","75067","75068","75069","75070","75071","75072","75074","75075","75076","75077","75078","75080","75081","75082","75083","75085","75086","75087","75088","75089","75090","75091","75092","75093","75094","75097","75098","75099","75101","75102","75103","75104","75105","75106","75109","75110","75114","75115","75116","75117","75118","75119","75120","75121","75123","75124","75125","75126","75127","75132","75134","75135","75137","75138","75140","75141","75142","75143","75144","75146","75147","75148","75149","75150","75151","75152","75153","75154","75155","75156","75157","75158","75159","75160","75161","75163","75164","75165","75166","75167","75168","75169","75172","75173","75180","75181","75182","75185","75187","75189","75201","75202","75203","75204","75205","75206","75207","75208","75209","75210","75211","75212","75214","75215","75216","75217","75218","75219","75220","75221","75222","75223","75224","75225","75226","75227","75228","75229","75230","75231","75232","75233","75234","75235","75236","75237","75238","75240","75241","75242","75243","75244","75246","75247","75248","75249","75250","75251","75252","75253","75254","75260","75261","75262","75263","75264","75265","75266","75267","75270","75275","75277","75283","75284","75285","75287","75301","75303","75312","75313","75315","75320","75326","75336","75339","75342","75354","75355","75356","75357","75358","75359","75360","75367","75368","75370","75371","75372","75373","75374","75376","75378","75379","75380","75381","75382","75389","75390","75391","75392","75393","75394","75395","75397","75398","75401","75402","75403","75404","75407","75409","75410","75411","75412","75413","75414","75415","75416","75417","75418","75420","75421","75422","75423","75424","75425","75426","75428","75429","75431","75432","75433","75434","75435","75436","75437","75438","75439","75440","75441","75442","75443","75444","75446","75447","75448","75449","75450","75451","75452","75453","75454","75455","75456","75457","75458","75459","75460","75461","75462","75468","75469","75470","75471","75472","75473","75474","75475","75476","75477","75478","75479","75480","75481","75482","75483","75485","75486","75487","75488","75489","75490","75491","75492","75493","75494","75495","75496","75497","75501","75503","75504","75505","75507","75550","75551","75554","75555","75556","75558","75559","75560","75561","75562","75563","75564","75565","75566","75567","75568","75569","75570","75571","75572","75573","75574","75599","75601","75602","75603","75604","75605","75606","75607","75608","75615","75630","75631","75633","75636","75637","75638","75639","75640","75641","75642","75643","75644","75645","75647","75650","75651","75652","75653","75654","75656","75657","75658","75659","75660","75661","75662","75663","75666","75667","75668","75669","75670","75671","75672","75680","75681","75682","75683","75684","75685","75686","75687","75688","75689","75691","75692","75693","75694","75701","75702","75703","75704","75705","75706","75707","75708","75709","75710","75711","75712","75713","75750","75751","75752","75754","75755","75756","75757","75758","75759","75760","75762","75763","75764","75765","75766","75770","75771","75772","75773","75778","75779","75780","75782","75783","75784","75785","75788","75789","75790","75791","75792","75797","75798","75799","75801","75802","75803","75831","75832","75833","75834","75835","75838","75839","75840","75844","75845","75846","75847","75848","75849","75850","75851","75852","75853","75855","75856","75858","75859","75860","75861","75862","75865","75880","75882","75884","75886","75901","75902","75903","75904","75915","75925","75926","75928","75929","75930","75931","75932","75933","75934","75935","75936","75937","75938","75939","75941","75942","75943","75944","75946","75948","75949","75951","75954","75956","75958","75959","75960","75961","75962","75963","75964","75965","75966","75968","75969","75972","75973","75974","75975","75976","75977","75978","75979","75980","75990","76001","76002","76003","76004","76005","76006","76007","76008","76009","76010","76011","76012","76013","76014","76015","76016","76017","76018","76019","76020","76021","76022","76023","76028","76031","76033","76034","76035","76036","76039","76040","76041","76043","76044","76048","76049","76050","76051","76052","76053","76054","76055","76058","76059","76060","76061","76063","76064","76065","76066","76067","76068","76070","76071","76073","76077","76078","76082","76084","76085","76086","76087","76088","76092","76093","76094","76095","76096","76097","76098","76099","76101","76102","76103","76104","76105","76106","76107","76108","76109","76110","76111","76112","76113","76114","76115","76116","76117","76118","76119","76120","76121","76122","76123","76124","76126","76127","76129","76130","76131","76132","76133","76134","76135","76136","76137","76140","76147","76148","76150","76155","76161","76162","76163","76164","76166","76177","76179","76180","76181","76182","76185","76190","76191","76192","76193","76195","76196","76197","76198","76199","76201","76202","76203","76204","76205","76206","76207","76208","76209","76210","76225","76226","76227","76233","76234","76238","76239","76240","76241","76244","76245","76246","76247","76248","76249","76250","76252","76253","76258","76259","76262","76263","76264","76266","76267","76268","76270","76271","76272","76273","76401","76402","76426","76431","76433","76436","76439","76446","76449","76453","76457","76461","76462","76463","76465","76467","76472","76475","76476","76484","76485","76486","76487","76490","76501","76502","76503","76504","76508","76511","76513","76518","76519","76520","76522","76523","76524","76525","76526","76527","76528","76530","76531","76533","76534","76537","76538","76539","76540","76541","76542","76543","76544","76547","76548","76549","76550","76554","76556","76557","76558","76559","76561","76564","76565","76566","76567","76569","76570","76571","76573","76574","76577","76578","76579","76596","76597","76598","76599","76621","76622","76623","76624","76626","76627","76628","76629","76630","76631","76632","76633","76634","76635","76636","76637","76638","76639","76640","76641","76642","76643","76644","76645","76648","76649","76650","76651","76652","76653","76654","76655","76656","76657","76660","76661","76664","76665","76666","76667","76670","76671","76673","76676","76678","76679","76680","76681","76682","76684","76685","76686","76687","76689","76690","76691","76692","76693","76701","76702","76703","76704","76705","76706","76707","76708","76710","76711","76712","76714","76715","76716","76797","76798","76799","77001","77002","77003","77004","77005","77006","77007","77008","77009","77010","77011","77012","77013","77014","77015","77016","77017","77018","77019","77020","77021","77022","77023","77024","77025","77026","77027","77028","77029","77030","77031","77032","77033","77034","77035","77036","77037","77038","77039","77040","77041","77042","77043","77044","77045","77046","77047","77048","77049","77050","77051","77052","77053","77054","77055","77056","77057","77058","77059","77060","77061","77062","77063","77064","77065","77066","77067","77068","77069","77070","77071","77072","77073","77074","77075","77076","77077","77078","77079","77080","77081","77082","77083","77084","77085","77086","77087","77088","77089","77090","77091","77092","77093","77094","77095","77096","77098","77099","77201","77202","77203","77204","77205","77206","77207","77208","77209","77210","77212","77213","77215","77216","77217","77218","77219","77220","77221","77222","77223","77224","77225","77226","77227","77228","77229","77230","77231","77233","77234","77235","77236","77237","77238","77240","77241","77242","77243","77244","77245","77248","77249","77251","77252","77253","77254","77255","77256","77257","77258","77259","77261","77262","77263","77265","77266","77267","77268","77269","77270","77271","77272","77273","77274","77275","77277","77279","77280","77282","77284","77287","77288","77289","77290","77291","77292","77293","77297","77299","77301","77302","77303","77304","77305","77306","77315","77316","77318","77320","77325","77326","77327","77328","77331","77332","77333","77334","77335","77336","77337","77338","77339","77340","77341","77342","77343","77344","77345","77346","77347","77348","77349","77350","77351","77353","77354","77355","77356","77357","77358","77359","77360","77362","77363","77364","77365","77367","77368","77369","77371","77372","77373","77374","77375","77376","77377","77378","77379","77380","77381","77382","77383","77384","77385","77386","77387","77388","77389","77391","77393","77396","77399","77401","77402","77404","77406","77407","77410","77411","77412","77413","77414","77415","77417","77418","77419","77420","77422","77423","77426","77428","77429","77430","77431","77432","77433","77434","77435","77436","77437","77440","77441","77442","77443","77444","77445","77446","77447","77448","77449","77450","77451","77452","77453","77454","77455","77456","77457","77458","77459","77460","77461","77463","77464","77465","77466","77467","77468","77469","77470","77471","77473","77474","77475","77476","77477","77478","77479","77480","77481","77482","77483","77484","77485","77486","77487","77488","77489","77491","77492","77493","77494","77496","77497","77498","77501","77502","77503","77504","77505","77506","77507","77508","77510","77511","77512","77514","77515","77516","77517","77518","77519","77520","77521","77522","77523","77530","77531","77532","77533","77534","77535","77536","77538","77539","77541","77542","77545","77546","77547","77549","77550","77551","77552","77553","77554","77555","77560","77561","77562","77563","77564","77565","77566","77568","77571","77572","77573","77574","77575","77577","77578","77580","77581","77582","77583","77584","77585","77586","77587","77588","77590","77591","77592","77597","77598","77611","77612","77613","77614","77615","77616","77617","77619","77622","77623","77624","77625","77626","77627","77629","77630","77631","77632","77639","77640","77641","77642","77643","77650","77651","77655","77656","77657","77659","77660","77661","77662","77663","77664","77665","77670","77701","77702","77703","77704","77705","77706","77707","77708","77710","77713","77720","77725","77726","77801","77802","77803","77805","77806","77807","77808","77830","77831","77833","77834","77835","77836","77837","77838","77840","77841","77842","77843","77844","77845","77850","77852","77853","77855","77856","77857","77859","77861","77862","77863","77864","77865","77866","77867","77868","77870","77871","77872","77873","77875","77876","77878","77879","77880","77881","77882","77901","77902","77903","77904","77905","77950","77951","77954","77957","77960","77961","77962","77963","77964","77967","77968","77969","77970","77971","77973","77974","77975","77976","77977","77978","77979","77982","77983","77984","77986","77987","77988","77989","77990","77991","77993","77994","77995","78001","78002","78003","78004","78005","78006","78007","78008","78009","78010","78011","78012","78013","78014","78015","78016","78017","78019","78021","78022","78023","78024","78025","78026","78027","78028","78029","78039","78040","78041","78042","78043","78044","78045","78046","78050","78052","78054","78055","78056","78057","78058","78059","78060","78061","78062","78063","78064","78065","78066","78067","78069","78070","78071","78072","78073","78074","78075","78076","78101","78102","78104","78107","78108","78109","78111","78112","78113","78114","78115","78116","78117","78118","78119","78121","78122","78123","78124","78125","78130","78131","78132","78133","78135","78140","78141","78142","78143","78144","78145","78146","78147","78148","78150","78151","78152","78154","78155","78156","78159","78160","78161","78162","78163","78164","78201","78202","78203","78204","78205","78206","78207","78208","78209","78210","78211","78212","78213","78214","78215","78216","78217","78218","78219","78220","78221","78222","78223","78224","78225","78226","78227","78228","78229","78230","78231","78232","78233","78234","78235","78236","78237","78238","78239","78240","78241","78242","78243","78244","78245","78246","78247","78248","78249","78250","78251","78252","78253","78254","78255","78256","78257","78258","78259","78260","78261","78263","78264","78265","78266","78268","78269","78270","78278","78279","78280","78283","78284","78285","78288","78289","78291","78292","78293","78294","78295","78296","78297","78298","78299","78330","78332","78333","78335","78336","78338","78339","78340","78341","78342","78343","78344","78347","78349","78350","78351","78352","78353","78355","78357","78358","78359","78360","78361","78362","78363","78364","78368","78369","78370","78371","78372","78373","78374","78375","78376","78377","78379","78380","78381","78382","78383","78384","78385","78387","78389","78390","78391","78393","78401","78402","78403","78404","78405","78406","78407","78408","78409","78410","78411","78412","78413","78414","78415","78416","78417","78418","78419","78426","78427","78460","78463","78465","78466","78467","78468","78469","78472","78480","78501","78502","78503","78504","78505","78516","78520","78521","78522","78523","78526","78535","78536","78537","78538","78539","78540","78541","78542","78543","78545","78547","78548","78549","78550","78551","78552","78553","78557","78558","78559","78560","78561","78562","78563","78564","78565","78566","78567","78568","78569","78570","78572","78573","78574","78575","78576","78577","78578","78579","78580","78582","78583","78584","78585","78586","78588","78589","78590","78591","78592","78593","78594","78595","78596","78597","78598","78599","78602","78604","78605","78606","78607","78608","78609","78610","78611","78612","78613","78614","78615","78616","78617","78618","78619","78620","78621","78622","78623","78624","78626","78627","78628","78629","78630","78631","78632","78633","78634","78635","78636","78638","78639","78640","78641","78642","78643","78644","78645","78646","78648","78650","78651","78652","78653","78654","78655","78656","78657","78658","78659","78660","78661","78662","78663","78664","78665","78666","78667","78669","78670","78671","78672","78673","78674","78675","78676","78677","78680","78681","78682","78683","78691","78701","78702","78703","78704","78705","78708","78709","78710","78711","78712","78713","78714","78715","78716","78717","78718","78719","78720","78721","78722","78723","78724","78725","78726","78727","78728","78729","78730","78731","78732","78733","78734","78735","78736","78737","78738","78739","78741","78742","78744","78745","78746","78747","78748","78749","78750","78751","78752","78753","78754","78755","78756","78757","78758","78759","78760","78761","78762","78763","78764","78765","78766","78767","78768","78772","78773","78774","78778","78779","78783","78799","78801","78802","78827","78828","78829","78830","78832","78833","78834","78836","78837","78838","78839","78840","78841","78842","78843","78847","78850","78851","78852","78853","78860","78861","78870","78871","78872","78873","78877","78879","78880","78881","78883","78884","78885","78886","78931","78932","78933","78934","78935","78938","78940","78941","78942","78943","78944","78945","78946","78947","78948","78949","78950","78951","78952","78953","78954","78956","78957","78959","78960","78961","78962","78963"]; 
    
    //put zipcode in the attributes to check
    $('#customer-zip-code').val(zipCode);
  
    //Check the zip codes for the two days 
    if (validZips.includes(zipCode)) {
      $.cookie('1 day shipping', 'true', { expires: 1 }); 
      $('#check-zip-container').remove();
      $('#csShippingAppCode').removeClass('hidden');
    } else {
      $.cookie('1 day shipping', 'false', { expires: 1 }); 
      $('#check-zip-container').remove();
      $('#csShippingAppCode').removeClass('hidden');
      setCalendarDates();
      }  
  });

  
  //set the second shipping day on the calendar
  function setCalendarDates() {
    let cCount = 1;
    $('.datepicker--cells-days .datepicker--cell-day').each(function(){
        if(cCount <= 40) {
         
          if(cCount == "3") {
            $(this).addClass('shipping-upcharge');
          }
          if(cCount == "10") {
            $(this).addClass('shipping-upcharge');
          }
          if(cCount == "17") {
            $(this).addClass('shipping-upcharge');
          }
          if(cCount == "24") {
            $(this).addClass('shipping-upcharge');
          }
          if(cCount == "31") {
            $(this).addClass('shipping-upcharge');
          }
          cCount = cCount + 1;
        }
     })
    
     $('#csShippingAppCode').addClass('two-day');

  
     setInterval(function() {
       
       //set the outline
       if(!$('.datepicker--cells-days .-current-').first().next().next().hasClass('-disabled-')){   
         $('#csShippingpicker .datepicker--cells-days .-current-').next().next().css('outline', '2px solid red').css('outline-offset', '-3px').addClass('shipping-upcharge').addClass('tuesday-shipping');
       }    

       if(!$('#shipping-legend').length > 0) {
         $("#csShippingAppCode").append("<h3 class='upcharge-note' id='shipping-legend'>Red outline indicates an overnight charge</h3>");
       } 

       let cCount = 1;
       $('.datepicker--cells-days .datepicker--cell-day').each(function(){
            if(cCount <= 40) {
             
              if(cCount == "3") {
                $(this).addClass('shipping-upcharge');
              }
              if(cCount == "10") {
                $(this).addClass('shipping-upcharge');
              }
              if(cCount == "17") {
                $(this).addClass('shipping-upcharge');
              }
              if(cCount == "24") {
                $(this).addClass('shipping-upcharge');
              }
              if(cCount == "31") {
                $(this).addClass('shipping-upcharge');
              }
              cCount = cCount + 1;
            }
        });
    }, 1000); 
  }

  //listen to the calendar
  $(document).on('click', '.datepicker--cell-day', function(){
      if($(this).hasClass('-disabled-')){
        //do nothing
      } else {
        if($('#csShippingAppCode').hasClass('unselected')){
          //add the date to the field
          let elMonth = $(this).data('month');
          elMonth = elMonth + 1;
          let elDay = $(this).data('date');
          let elYear = $(this).data('year');

          //add the date to the field
          $('#expected-delivery-date').text('Your Delivery Day: ' + elMonth + '/' + elDay + '/' + elYear);
          $('#reset-date').removeClass('hidden');
          $('#csShippingAppCode').addClass('hidden').removeClass('unselected').addClass('selected');
          $('#customer-delivery-date').val(elMonth + '/' + elDay + '/' + elYear)
           
          if($(this).hasClass('-disabled-')){ 
          } else {
            //check selected for class
            if($(this).hasClass('shipping-upcharge')){
              //set overnight shipping to true
            
              $('#overnight-shipping-note').removeClass('hidden');
              $('#alert-box').addClass('active');
              $('#express-shipping').val('true');
              overNightShipping = 'true';
              window.setTimeout(function(){
                $('#alert-box').removeClass('active');
              }, 4000)
            }
            //scroll the page up
            $('#checkout-button').removeClass('hidden');
            $('html, body').animate({ scrollTop: 0 }, 'slow');
         
          }
        } else {
          //do nothing
        }
    }
  }) 
 
  $('#checkout-button').click(function(e){

    //lets control the current date
    let cDate = $('#csShippingDateValue').val();
    let currentDay  = $('#csShippingDayValue').val();
    let expShipDay = '';

    //convert the date to a number so we know what day to adjust
    currentDay = dayNameToNumber(currentDay);

    var dateString = cDate;
    var [month, day, year] = dateString.split("/");
    var expShipDateObject = new Date(year, month - 1, day); // Month is 0-indexed
    
   

    if($('#checkout-button').hasClass('non-perishables')){
      //do nothing and go to the cart
    } else {
      e.preventDefault();

      //lets remove all the disabled dates & other months
      $('#csShippingpicker .datepicker--cell').removeClass('-disabled-').removeClass('-other-month-');

      if($('#csShippingAppCode').hasClass('two-day')){
         if ($('.-selected-').first().hasClass('shipping-upcharge')) {

           

           expShipDay = formatDate(subtractDays(expShipDateObject, 1));
           $('#order_ship_date').val(expShipDay);
           
           $('#csTimeShippingVal').children('.cs-time-picker').last().addClass('time-selector-cheat');
           $('.time-selector-cheat').first().click();
        
         } else {
           

           expShipDay = formatDate(subtractDays(expShipDateObject, 2));
           $('#order_ship_date').val(expShipDay);
           
           //create the element for the selector on the time 
           $('#csTimeShippingVal').children('.cs-time-picker').last().addClass('time-selector-cheat');
           $('#csTimeShippingVal').children('.cs-time-picker').first().click();
         }
 
      } else {

        
        
        expShipDay = formatDate(subtractDays(expShipDateObject, 1));
        $('#order_ship_date').val(expShipDay);
        
        //create the element for the selector on the time 
        $('#csTimeShippingVal').children('.cs-time-picker').last().addClass('time-selector-cheat');
        $('#csTimeShippingVal').children('.cs-time-picker').first().click();
      }

      if($('#order_ship_date').val()){
        //set timoute and submit here
        window.setTimeout(function(){
          $('#cart-form').submit();  
      }, 1400)
      } else {
        alert('There Was a Mistake, Please Choose Your Correct Shipping Date.')
        window.location.href = "https://www.44steaks.com/cart"
      }
    }
  })

  //date alteration object
  function addDays(date, days) {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + days);
    return newDate;
  }
  
  function subtractDays(date, days) {
    return addDays(date, -days);
  }

  //convert the day of the week into the number
  function dayNameToNumber(dayName) {
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const dayNumber = daysOfWeek.indexOf(dayName);
  
    if (dayNumber === -1) {
      return "Invalid day name"; // Handle invalid input
    } else {
      return dayNumber;
    }
  }

  function formatDate(date) {
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  /*
  window.setTimeout(function(){
    $(".klaviyo-close-form").on("click", function () {
      $('.kl-private-reset-css-Xuajs1').remove();
    });
  }, 1500)


  if($('#corporate-icons').length > 0) {
  } else {
    $(window).scroll(function(event) {
      var fullHomeHeight = $(window).height();
      var scroll = $(window).scrollTop();
      if (scroll >= (20)) {
          $('.kl-private-reset-css-Xuajs1').remove();
      }
    });
  }

  */

  /*----------------------
    Cart Checkout Feature
  -----------------------*/

  $('.Faq__Item').click(function(){
  	$(this).find('.Faq__AnswerWrapper').toggleClass('active');
  })

  

  
 //collection slick slider 
  $('.slick-slider-collection').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }     
    ]
  });
  
  //collection slick slider 
  $('.slick-slider-products').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }     
    ]
  
  });

  //fire up the AOS
  AOS.init();
  
  //footer menu box
  $('.foot-menu-box').click(function(){
  	$(this).find('ul').first().toggleClass('active');
    $(this).find('h3').first().toggleClass('active');
  });
  
  //Navigation Filter Dropwdown
  $('.filter-top .Collapsible__Button').click(function(){
    
    //check for active headline
    if($(this).hasClass('active')){
       $('.filter-top .Collapsible__Inner').removeClass('active');
       $(this).removeClass('active');
    } else {
      
      //clear all the top buttons
      $('.filter-top .Collapsible__Button').removeClass('active');
      
      //add active class to the the link
      $(this).addClass('active');  
  	  
      //remove the filter actives 
      $('.filter-top .Collapsible__Inner').removeClass('active');

      $(this).closest('.filter-top').find('.Collapsible__Inner').addClass('active');
    }
  })

let cartDiscountFound = false; // Use let for block-scoping
/* Check cart referral and use it for the discount code feature */
const cCURL = window.location.href;
if (cCURL.includes('?discountCodeCheck=true')) {
  // Function to fetch cart data and check for discounts
  async function checkCartForDiscounts() {
    try {
      const response = await fetch('/cart.json');
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const cartData = await response.json();

      if (cartData && cartData.items) {
        for (const item of cartData.items) {
          if (item.discounts && item.discounts.length > 0) {
            return true; // Return true as soon as a discount is found
          }
        }
      } else {
        console.log('Cart is empty or invalid cart data.');
      }
      return false; // Return false if no discounts are found
    } catch (error) {
      console.error('Error fetching cart data:', error);
      return false; // Return false in case of an error
    }
  }

  // Check the cart for discounts and then proceed
  checkCartForDiscounts().then(discountFound => {
    cartDiscountFound = discountFound; // Update the outer variable
      if (!cartDiscountFound) {    
        window.location.href = "https://www.44steaks.com/cart?code=failed";
      } else {
        window.location.href = "https://www.44steaks.com/cart?code=success";
      }
  });
}

//check the url for code applied  
if (cCURL.includes("44steaks.com/cart")) {
  if(cCURL.includes('?code=failed')) {
    $('.discount-fail-message').css('display','block');
  } 
  if(cCURL.includes('?code=success')) {
    $('.cart-discount-wrapper').remove();
  } 
}

//finally, drop the code if that is the case 
  
if (cCURL.includes("44steaks.com/cart")) {

    // Function to fetch cart data and check for discounts
    function checkCartForDiscounts() {
      fetch('/cart.json')
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(cartData => {
          if (cartData && cartData.items) {
            let discountFound = false;
            cartData.items.forEach(item => {
              if (item.discounts && item.discounts.length > 0) {
                discountFound = true;
                $('.cart-discount-wrapper').remove();
              }
            });        
          } else {
            console.log('Cart is empty or invalid cart data.');
          }
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
        });
    }
    // Check the cart for discounts
    checkCartForDiscounts();

}
  
});
  